import tokenStorage from "~/services/tokenStorage";
import {ADMIN_AUTH_TOKEN} from "~/Admin/services/http/adminAxios";

const initialState = {
};

export default function (state = initialState, action) {

    const {payload, type} = action

    switch (type) {
        case 'CONFIG_LOADED':
            return payload;

        default:
            return state;
    }
}
